import { call, put, takeLatest } from "redux-saga/effects";
import { ActionTypes, Update } from "@app/store/reducers/data.reducer";

import { firebase } from '@app/services/firebase.service';

function* configSaga(): any
{
    try 
    {
        const conf = yield call(fetchConfig);
        yield put(Update({ config: conf }));
    }
    catch (error)
    {
        console.log(error);
        //yield put(fetchTasksError(error.message));
    }
}


function* stageSaga(action): any
{
    try 
    {
        const { stageId } = action.payload || {};
        const stage = yield call(fetchStage, stageId);
        yield put(Update({ stage: stage, date: new Date().valueOf() }));
    }
    catch (error)
    {
        console.log(error);
        //yield put(fetchTasksError(error.message));
    }
}

export function* watchDataSaga()
{
    yield takeLatest(ActionTypes.Load, configSaga);
    yield takeLatest(ActionTypes.Fetch, stageSaga);
}
export default watchDataSaga;

const fetchConfig = async () =>
{
    return await firebase.firestore().collection("config").doc("release").get()
        .then(res => ({ docId: res.id, ...res.data() }))
        .catch(e => console.log(e));
}
const fetchStage = async (stageId) =>
{
    return await firebase.firestore().collection("stages").doc(stageId).get()
        .then(res => ({ docId: res.id, ...res.data() }))
        .catch(e => console.log(e));
}